import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const getPersonalityAssessment = createAsyncThunk(
  "getPersonalityAssessment",
  async ({ candidateId, jobId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/personality-assessment/get`,
        { candidateId, jobId }
      );
      if (data.success) return { candidateId, data: data.data };
      return rejectWithValue(data.message);
    } catch (error) { return rejectWithValue(error.message); }
  }
);

const computePersonalityAssessment = createAsyncThunk(
  "computePersonalityAssessment",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/personality-assessment/compute`,
        payload
      );
      if (data.success) return { candidateId: payload.candidateId, data: data.data };
      return rejectWithValue(data.message);
    } catch (error) { return rejectWithValue(error.message); }
  }
);

export { getPersonalityAssessment, computePersonalityAssessment };
